import React, { useState } from "react";
import { CompanyLogoSection, InfoGameSection, SocialSection, VersionSelectSection } from "./Sections";
import { IHeaderProps } from "./IHeaderProps";
import { FullScreenSection } from "./Sections/FullScreenSection";
import { useIsMobile } from "../../Hooks";
import { Button, MantineProvider } from "@mantine/core";
import { MdOutlineShoppingBag } from "react-icons/md";
import { useTranslation } from "react-i18next";
import OpenApiClient from "../../../../Api/OpenApiClient";
import useAsyncEffect from "use-async-effect";
import { useElementSize } from "@mantine/hooks";
import { MenuSection } from "./Sections/MenuSection";
import { webPlayerStore } from "../../store/webPlayerStore";

export const getGameStoreUrl = async (game: string, redirectWithTempToken: boolean) => {
	let url = new URL(`Store/${game}`, window.location.origin);
	if (redirectWithTempToken) {
		const { TempToken } = await OpenApiClient.Auth.fxIdWebFeaturesAuthCreateTempTokenEndpoint({
			RedirectUri: `/Store/${game}`
		});
		url = new URL(`/LoginWithTempToken`, window.location.origin);
		url.searchParams.append("token", TempToken);
	}

	log.info(`Got store URL: ${url}`);
	return url;
};

const useGameStoreUrl = (game: string, isMainSite: boolean) => {
	const [storeUrl, setStoreUrl] = useState<URL>();

	useAsyncEffect(async () => {
		const url = await getGameStoreUrl(game, !isMainSite);
		setStoreUrl(url);
	}, []);

	return storeUrl;
};

export const Header = (props: IHeaderProps) => {
	const { t } = useTranslation();
	const gameConfig = webPlayerStore((state) => state.gameConfig);

	const isMobile = useIsMobile();

	const storeUrl = useGameStoreUrl(gameConfig.GameSystemName, props.isMainSite);

	const { ref, width } = useElementSize();

	return (
		<MantineProvider theme={{ components: { Menu: { styles: { itemLabel: { color: "#000" } } } } }}>
			<div className="header-container">
				<header className="header">
					<CompanyLogoSection width={width} />
					<InfoGameSection />
					<VersionSelectSection />
					<div className="header-actions" ref={ref}>
						{!props.disableStoreLink && !isMobile && storeUrl && (
							<a target="_blank" rel="noreferrer" href={storeUrl.toString()}>
								<Button
									compact
									sx={{ height: 24 }}
									px={10}
									size="xs"
									rightIcon={<MdOutlineShoppingBag size={16} />}
								>
									{t("store.store_front_title")}
								</Button>
							</a>
						)}
						{gameConfig.PublicWebClientConfig.SocialSectionAvailable && <SocialSection />}
						<MenuSection />
						<FullScreenSection {...props} />
					</div>
				</header>
			</div>
		</MantineProvider>
	);
};
